// extracted by mini-css-extract-plugin
module.exports = {"text":"partnerListComponent_text__ANlWi","hide":"partnerListComponent_hide__qk3TZ"};